import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useApiFunction from "../../api/useApiFunction";
import valueContext from "../../customHook/useContext";

function MemberDownline() {
  let [search, setSearch] = useState("");
  const { joinToken } = useContext(valueContext);

  const token = joinToken();
  const [show, setShow] = useState(false);
  const [data, setData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { formDataFunc } = useApiFunction();
  const navigate = useNavigate();

  async function submitDownline(e) {
    e.preventDefault();
    setIsLoading(true);
    if (!search) {
      toast.warning("Please fill the detail", {
        autoClose: 2000
      });
    } else {
      let body = JSON.stringify({
        search: search
      });
      const res = await formDataFunc(`admin/getDownline`, body, "POST", token);
      if (res.status) {
        setShow(true);
        setData(res.msg);
        setSearch("");
      } else if (
        res.error &&
        (res.error === "ERROR_TOKEN_INVALID0" ||
          res.error === "ERROR_TOKEN_INVALID1" ||
          res.error === "user not registered" ||
          res.error === "ERROR_TOKEN_INVALID2" ||
          res.error === "ERROR_TOKEN_INVALID3" ||
          res.error === "unauthorized" ||
          res.error === "Your session has expierd Please login again 1" ||
          res.error === "Your session has expierd Please login again 2")
      ) {
        window.localStorage.removeItem("_A");
        window.localStorage.removeItem("_B");
        window.localStorage.removeItem("_C");
        navigate("/admin/login");
      } else if (res.error) {
        toast.warning(res.error, { autoClose: 2000 });
      } else {
        toast.warning(res.msg, { autoClose: 2000 });
      }
    }
    setIsLoading(false);
  }

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-18">Member Downline</h4>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-8">
              <div className="card profile-section">
                <div className="card-body">
                  <div className="col-lg-12 col-md-12 col-sm-6">
                    <form onSubmit={e => submitDownline(e)}>
                      <div className="form-group mb-3">
                        <label for="" className="sub-heading col-form-label">
                          Username
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter your username"
                          value={search}
                          onChange={e => {
                            setSearch(e.target.value);
                          }}
                        />
                      </div>

                      <div className="mt-3">
                        <button
                          className="block-menu"
                          type="submit"
                          disabled={isLoading}
                        >
                          {isLoading && (
                            <i
                              className="bx bx-loader-circle rotating"
                              style={{ marginRight: "5px" }}
                            />
                          )}
                          Search
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            {show && (
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <h4 className="card-title table-head">
                        Member Downline List
                      </h4>

                      <div className="table-responsive table-line">
                        <table
                          className="table align-middle mb-0"
                          id="order-listing"
                        >
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Name</th>
                              <th>userName</th>
                              <th>email</th>
                              <th>Tallwin ID</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data && data.length > 0 ? (
                              data.map((data, i) => {
                                return (
                                  <tr>
                                    <th scope="row">{i + 1}</th>
                                    <td>
                                      {data?.memberDetails.length > 0
                                        ? data?.memberDetails[0].name
                                        : "-"}
                                    </td>
                                    <td>
                                      {data?.memberDetails.length > 0
                                        ? data?.memberDetails[0].userName
                                        : "-"}
                                    </td>
                                    <td>
                                      {data?.memberDetails.length > 0
                                        ? data?.memberDetails[0].email
                                        : "-"}
                                    </td>
                                    <td>
                                      {data?.memberDetails.length > 0
                                        ? data?.memberDetails[0].twlUserName
                                          ? data?.memberDetails[0].twlUserName
                                          : "--"
                                        : "-"}
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <p>NO DATA</p>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MemberDownline;
